import React from 'react';
import StatisticTile from './StatisticTile';
import PropTypes from 'prop-types';

const StatisticsTiles = (props) => {

  const statistics = props.statistics && props.statistics[0] ? props.statistics[0] : {};
  const products = props.products || null

  return (<div className="row space-evenly">
    {mapStorageStatistics(statistics)}
    {mapProductsStatistics(products)}
  </div>);


  function mapStorageStatistics(storage) {
    if (!storage) return null;

    const storagePercentage = (storage.storage_used) ? `${storage.storage_used.toFixed(2)} MB` : '0 MB';
    const trafficPercentage = (storage.traffic_used) ? `${(storage.traffic_used).toFixed(2)} MB` : '0 MB';

    const storageAvailable = storage && (storage.storage_available || storage.storage_available === 0) ? `${storage.storage_available} MB` : ''
    const trafficAvailable = storage && (storage.traffic_available || storage.traffic_available === 0) ? `${storage.traffic_available} MB`  : ''

    const jsxArray = [];
    jsxArray.push(<StatisticTile key="Storage" title="Storage" data={storagePercentage} subTitle="Of Total Available" details={storageAvailable} icon="s7-graph" />);
    jsxArray.push(<StatisticTile key="Download" title="Download" data={trafficPercentage} subTitle="Of Total Available" details={trafficAvailable} icon="s7-graph3" />);

    return jsxArray;
  }

  function mapProductsStatistics(products) {
    if (!products) return null;

    const totalViews = products.views.toString() || "";
    const totalVisits = products.websiteVisits.toString() || "";

    const jsxArray = [];
    jsxArray.push(<StatisticTile key="Views" title="Views" data={totalViews} subTitle="Times" details={""} icon="fa fa-eye" />);
    jsxArray.push(<StatisticTile key="Visited Link" title="Visited Link" data={totalVisits} subTitle="Total Visits" details={""} icon="fa fa-link" />);

    return jsxArray;
  }
}

StatisticsTiles.propTypes = {
  statistics: PropTypes.array,
  products: PropTypes.object
}

StatisticsTiles.defaultProps = {
  statistics: [],
  products: null
};


export default StatisticsTiles;



// WEBPACK FOOTER //
// ./src/components/Statistics/StatisticsTiles.js